import GenericTable from "../Tables/GenericTable";
import MDButton from "components/MDButton";
import DefaultCell from "../Tables/components/DefaultCell";
import { GET_ALL_QUERY, GetAllGql, GetAllItem } from "./queries/getAll";
import { getStatusCell } from "../Tables/GenericTable/utils/getStatusCell";
import ModalCustom from "../ModalCustom";
import { ModalTableSelect } from "../JsonForm/renderers/SelectMultiple/types";

const btnStyle = {
  border: "1px solid #7b809a",
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 1,
};

const btnStyleRemove = {
  ...btnStyle,
  border: "1px solid #F44335",
  color: "#F44335",
};

export default function ModalBlogPostsSelect({
  ids,
  handleOpen,
  onChange,
  open,
}: ModalTableSelect) {
  return (
    <ModalCustom
      onClose={handleOpen}
      open={open}
      sx={{
        "& .head": {
          justifyContent: "center",
          width: "100%",
        },
      }}
    >
      <GenericTable<GetAllGql>
        initialVariables={{
          page: 1,
          perPage: 8,
          search: null,
          status: null,
        }}
        path={`/ecommerce/blogs`}
        query={GET_ALL_QUERY}
        formatRows={(data) => data.Blogs.items}
        formatPagination={(data) => data.Blogs.paginationInfo}
        columnsTable={[
          {
            Header: "Ação",
            accessor: "id",
            Cell: ({ value, cell }: any) => (
              <MDButton
                sx={ids.includes(Number(value)) ? btnStyleRemove : btnStyle}
                onClick={() => {
                  const data = cell.row.original as GetAllItem;
                  onChange({ ...data, name: data.title });
                }}
              >
                {ids.includes(Number(value)) ? "Remover" : "Adicionar"}
              </MDButton>
            ),
          },
          {
            Header: "Títutlo",
            accessor: "title",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Nome",
            accessor: "name",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Autor",
            accessor: "autor",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "status",
            accessor: "status",
            Cell: ({ value }: any) => getStatusCell(value),
          },
          {
            Header: "Publicação",
            accessor: "publishOn",
            Cell: ({ value }: any) => (
              <DefaultCell value={value ? new Date(value).toLocaleDateString("pt-BR") : "Sem data"} />
            ),
          },
        ]}
      />
    </ModalCustom>
  );
}
